import { createStyles, keyframes } from '@mantine/core';
import type { TextProps } from '@repo/foundations';
import { Text } from '@repo/foundations';

const textShine = keyframes`
	to {
		background-position: -200% center;
	}
`;

const useStyles = createStyles((theme) => ({
	thinkingText: {
		background: `linear-gradient(to right, ${theme.fn.lighten(theme.other.getColor('text/secondary/default'), 0.5)} 0%, ${theme.other.getColor('text/secondary/default')} 20%, ${theme.other.getColor('text/secondary/default')} 90%, ${theme.fn.lighten(theme.other.getColor('text/secondary/default'), 0.5)} 95%)`,
		backgroundClip: 'text',
		textFillColor: 'transparent',
		backgroundSize: '200% auto',
		animation: `${textShine} 1s linear infinite`,
	},
}));

type ThinkingTextProps = TextProps;

export function ThinkingText({
	children,
	className,
	...props
}: ThinkingTextProps) {
	const { classes, cx } = useStyles();

	return (
		<Text {...props} className={cx(classes.thinkingText, className)}>
			{children}
		</Text>
	);
}
